<template>
    <div id="tableview">
      <v-data-table id="datatable" :headers="headers" :items="locations" :group-by="groupBy" item-key="id" mobile-breakpoint="200"  
                    dense disable-pagination disable-sort disable-filter fixed-header hide-default-footer :height="theight" v-resize="onResize" :expanded="[]" >

        <template v-slot:group.header="slotProps">
            <td v-show="!(viewType==0)" class="stickyfirst font-weight-bold gray lighten-3" colspan="4"> 
              <v-btn icon color="black" @click="slotProps.toggle()" :ref="slotProps.group" :data-open="slotProps.isOpen">
                <v-icon v-show="slotProps.isOpen">mdi-chevron-up</v-icon>
                <v-icon v-show="!slotProps.isOpen">mdi-chevron-down</v-icon>
              </v-btn>   
              {{slotProps.group}} 
              <v-btn icon @click="onFavClick(slotProps.group)">
                  <v-icon v-show="hasFavLocation(slotProps.group)" small color="black">mdi-star</v-icon>
                  <v-icon v-show="!hasFavLocation(slotProps.group)" small>mdi-star-outline</v-icon>                            
              </v-btn>
            </td>
            <td v-show="!(viewType==0)" class="gray lighten-3" colspan="10"> </td>
        </template>

        <template slot="item" slot-scope="props">
          <tr>
            <td class="stickyfirst nowrap grey lighten-3"> 
              <span v-show="(viewType == 1 || viewType ==2)"> {{ props.item.param }} </span>
              <span v-show="(viewType == 0)"> {{ props.item.location }} </span> 
            </td>
            <td :class="getColorFromValue(props.item.param, props.item.jan)"> {{ Math.round(props.item.jan) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.feb)"> {{ Math.round(props.item.feb) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.mar)"> {{ Math.round(props.item.mar) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.apr)"> {{ Math.round(props.item.apr) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.may)"> {{ Math.round(props.item.may) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.jun)"> {{ Math.round(props.item.jun) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.jul)"> {{ Math.round(props.item.jul) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.aug)"> {{ Math.round(props.item.aug) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.sep)"> {{ Math.round(props.item.sep) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.oct)"> {{ Math.round(props.item.oct) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.nov)"> {{ Math.round(props.item.nov) }}</td> 
            <td :class="getColorFromValue(props.item.param, props.item.dec)"> {{ Math.round(props.item.dec) }}</td> 
            <td>{{ Math.round(props.item.year) }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
</template>

<script>
import * as datafile from "../LocationData.js";
import * as GLOBALS from "../globals.js";

export default {
  data: () => ({
    headers: [
      //{ text: "Location", value: "location" },
      { text: "", value: "param", width: "100px" },
      { text: "Jan", value: "jan", width: "60px" },
      { text: "Feb", value: "feb", width: "60px" },
      { text: "Mar", value: "mar", width: "60px" },
      { text: "Apr", value: "apr", width: "60px" },
      { text: "May", value: "may", width: "60px" },
      { text: "Jun", value: "jun", width: "60px" },
      { text: "Jul", value: "jul", width: "60px" },
      { text: "Aug", value: "aug", width: "60px" },
      { text: "Sep", value: "sep", width: "60px" },
      { text: "Oct", value: "oct", width: "60px" },
      { text: "Nov", value: "nov", width: "60px" },
      { text: "Dec", value: "dec", width: "60px" },
      { text: "Year", value: "year", width: "100px" }
    ],
    theight: 800,
    viewType: 1,    // 0 = parameterView / 1 = standard view / 2 = enhanced view
    myLocationsFilter: false,
    groupBy: 'location',
    locations: datafile.locationData.slice()
  }),
  created: function () {
    
  },
  mounted: function() {
      //this.$nextTick(this.onResize);
  },
  methods: {
    // Public Methods ==============================================
    collapseAll: function() {
      Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    expandAll: function() {
      Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },    
    filterMyLocations: function() {
      for (var i = this.locations.length - 1; i >= 0; --i) {
            if(!GLOBALS.hasFavLocation(this.locations[i].location)) {
              this.locations.splice(i,1);
          }
      }
      this.myLocationsFilter = true;
    },
    showAllLocations: function() {
      this.locations = datafile.locationData.slice();
      this.myLocationsFilter = false;
      this.setViewType(this.viewType);
    },
    setViewType: function(vType) {    
      var stdViewParams = datafile.param_MT + datafile.param_Rm;
      var paramViewParam = datafile.param_Rm;
      var groupBy = '';
      var headerText = '';

      this.locations = datafile.locationData.slice();   // reset the local data set

      switch (vType) {
        case 0: // parameter view
          for (var i = this.locations.length - 1; i >= 0; --i) {
              if(paramViewParam.search(this.locations[i].param) == -1) {
                  this.locations.splice(i,1);
              }
          }
          groupBy = '';
          headerText = paramViewParam;
          break;

        case 1: // standard view
          for (var i = this.locations.length - 1; i >= 0; --i) {
            if(stdViewParams.search(this.locations[i].param) == -1) {
              this.locations.splice(i,1);
            }
          }
          groupBy = 'location';
          headerText = '';
          break;

        case 2: // enhanced view
          groupBy = 'location';
          headerText = '';
          break;      
      } 

      if (this.myLocationsFilter) {
        this.filterMyLocations();
      }

      this.setHeaderText(headerText);
      this.viewType = vType;
      this.groupBy = groupBy;
    },        
    // End Public Methods ============================================    
    // round: function (value) {
    //   return Math.sign(value) * Math.round(Math.abs(value));
    // },
    getColorFromValue: function(param, value) {
      return GLOBALS.getColorFromValue(param, value);
    },
    hasFavLocation: function(location) {
      return GLOBALS.hasFavLocation(location);
    },
    addFavLocation: function(location) {
      return GLOBALS.addFavLocation(location);
    },
    delFavLocation: function(location) {
      return GLOBALS.delFavLocation(location);
    },    
    onFavClick: function(location) {
        if(GLOBALS.hasFavLocation(location)) {
          GLOBALS.delFavLocation(location)
        } else {
          GLOBALS.addFavLocation(location);
        }
        this.$forceUpdate();
    },
    setHeaderText: function (headtext) {
      this.headers.forEach( (item, index, arr) => {
        if (arr[index].value == 'param') { arr[index].text = headtext; }
      });
    },
    // truncateString: function (str, num) {
    //   if (str.length <= num) {
    //     return str;
    //   }
    //   return str.slice(0, num) + '...';
    // },
    onResize: function() {
      var maxHeight;
      var tableView = document.getElementById("datatable");
      var appToolbar = document.getElementById("apptoolbar");

      if(typeof appToolbar === 'object' && appToolbar !== null) { 
        maxHeight =  window.innerHeight - appToolbar.offsetHeight; 
      } else 
      {
        maxHeight = window.innerHeight - 50;
      }
      
      if(typeof tableView === 'object' && tableView !== null) { 
        this.theight = maxHeight + "px";
        //console.log("Resize tableview, set Max Height: " + maxHeight);
      }
    }
    // deleteLocation: function(location) {
    //   for (var i = this.locations.length - 1; i >= 0; --i) {
    //     if(location.search(this.locations[i].location) != -1) {
    //         this.locations.splice(i,1);
    //     }
    //   }
    // }
  }     
};

</script>

<style>

.stickyfirst {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
}

.nowrap { 
  white-space: nowrap; 
}

</style>